import { render, staticRenderFns } from "./serviceProvider.vue?vue&type=template&id=5058c384&scoped=true&"
import script from "./serviceProvider.vue?vue&type=script&lang=ts&"
export * from "./serviceProvider.vue?vue&type=script&lang=ts&"
import style0 from "./serviceProvider.vue?vue&type=style&index=0&id=5058c384&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5058c384",
  null
  
)

export default component.exports